import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { useAuth } from "../../Context/auth"; // ALTERAÇÃO: Usar nosso AuthContext
import MenuLateral from "../../Components/MenuPrincipal/MenuLateral";
import ClientesGrid from "../../Components/ClientesGrid/clientesGrid";
import Pagination from "../../Components/Pagination/Pagination";
import './clientes.css';

function Clientes() {
    const { currentUser } = useAuth(); // ALTERAÇÃO: Pegar usuário do nosso contexto
    const navigate = useNavigate(); // Hook do Router
    // ... states ...

    const handleEditar = (id) => {
        navigate(`/app/gerencial/clientes/editar/${id}`);
    };
    const [todosClientes, setTodosClientes] = useState([]); // RESTORED
    const [clientesFiltrados, setClientesFiltrados] = useState([]);
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState('');
    const [pesquisa, setPesquisa] = useState('');
    const [textoPesquisa, setTextoPesquisa] = useState('');
    const [trigger, setTrigger] = useState(0); // Gatilho para recarregar

    const [itemsPerPage, setItemsPerPage] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);

    // ALTERAÇÃO: Função buscarDados totalmente refeita para usar a API
    const buscarDados = useCallback(async () => {
        if (!currentUser) return;
        setCarregando(true);
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;

            const response = await fetch(`${API_URL}/api/gerencial/clientes`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Você não tem permissão para ver esta página.");
            }
            const data = await response.json();

            setTodosClientes(data);
            setClientesFiltrados(data);
        } catch (error) {
            console.error("Erro ao carregar dados dos clientes:", error);
            setErro(error.message);
        } finally {
            setCarregando(false);
        }
    }, [currentUser]);

    useEffect(() => {
        buscarDados();
    }, [buscarDados, trigger]);

    useEffect(() => {
        if (textoPesquisa) {
            const termo = textoPesquisa.toLowerCase();
            const resultado = todosClientes.filter(cliente =>
                cliente.nome?.toLowerCase().includes(termo) ||
                cliente.cpf_cnpj?.toLowerCase().includes(termo)
            );
            setClientesFiltrados(resultado);
            setCurrentPage(1); // Reset page on search
        } else {
            setClientesFiltrados(todosClientes);
        }
    }, [textoPesquisa, todosClientes]);

    // ... (rest of the delete/renew handlers unchanged)

    const handleExcluir = async (id) => {
        const result = await Swal.fire({
            title: 'Confirmar Exclusão',
            text: "Esta ação removerá o registro do cliente. Deseja continuar?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/gerencial/clientes/${id}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error);
                }
                Swal.fire('Excluído!', 'O cliente foi removido com sucesso.', 'success');
                setTrigger(Date.now());
            } catch (error) {
                Swal.fire('Erro!', error.message, 'error');
                console.error("Erro ao excluir cliente: ", error);
            }
        }
    };

    const handleRenovar = async (id) => {
        const { value: novaData } = await Swal.fire({
            title: 'Renovar Assinatura',
            input: 'date',
            inputLabel: 'Selecione a nova data de vencimento',
            inputPlaceholder: 'dd/mm/aaaa',
            confirmButtonText: 'Salvar',
            showCancelButton: true,
            cancelButtonText: 'Cancelar'
        });

        if (novaData) {
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                await fetch(`${API_URL}/api/gerencial/clientes/${id}/renovar`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ novaData: novaData + "T12:00:00" })
                });
                Swal.fire('Sucesso!', 'A data de vencimento foi atualizada.', 'success');
                setTrigger(Date.now());
            } catch (error) {
                Swal.fire('Erro!', 'Não foi possível atualizar a data.', 'error');
                console.error("Erro ao renovar assinatura: ", error);
            }
        }
    };

    const handlePesquisar = () => {
        setTextoPesquisa(pesquisa);
    };

    const handleAtualizar = () => {
        setPesquisa('');
        setTextoPesquisa('');
        setTrigger(Date.now());
    };

    // Pagination Logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentClientes = clientesFiltrados.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
    const handleItemsPerPageChange = (newLimit) => {
        setItemsPerPage(newLimit);
        setCurrentPage(1);
    };

    return (
        <div className="marcas-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />

            <div className="content-with-sidebar">
                <div className="marcas-header">
                    <h1 className="marcas-title">
                        <i className="fas fa-users text-primary"></i>
                        Gerenciamento de <span className="highlight">Clientes</span>
                    </h1>
                </div>

                <main className="marcas-content" style={{ maxWidth: '98%' }}>
                    <div className="marcas-controls">
                        <button
                            className="btn-primary-custom me-3"
                            onClick={() => navigate('/app/gerencial/clientes/novo')}
                        >
                            <i className="fas fa-plus"></i>Novo Cliente
                        </button>

                        <div className="search-wrapper">
                            <i className="fas fa-search search-icon"></i>
                            <input
                                type="text"
                                className="search-input-custom"
                                placeholder="Pesquisar por Nome ou CPF/CNPJ..."
                                value={pesquisa}
                                onChange={(e) => setPesquisa(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && handlePesquisar()}
                            />
                        </div>

                        <button className="btn-icon-custom ms-2" onClick={handlePesquisar} title="Pesquisar">
                            <i className="fas fa-search"></i>
                        </button>

                        <button className="btn-icon-custom ms-2" onClick={handleAtualizar} disabled={carregando} title="Atualizar Lista">
                            <i className={`fas fa-sync-alt ${carregando ? 'fa-spin' : ''}`}></i>
                        </button>
                    </div>

                    {erro && (
                        <div className="alert alert-danger d-flex align-items-center mb-4" role="alert">
                            <i className="fas fa-exclamation-triangle me-2"></i>
                            <div>{erro}</div>
                        </div>
                    )}

                    {carregando ? (
                        <div className="text-center p-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Carregando...</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <ClientesGrid
                                arrayClientes={currentClientes}
                                clickDelete={handleExcluir}
                                clickRenovar={handleRenovar}
                                clickEdit={handleEditar}
                            />

                            <Pagination
                                totalItems={clientesFiltrados.length}
                                itemsPerPage={itemsPerPage}
                                currentPage={currentPage}
                                onPageChange={handlePageChange}
                                onItemsPerPageChange={handleItemsPerPageChange}
                            />
                        </>
                    )}
                </main>
            </div>
        </div>
    );
}

export default Clientes;